export const VEHICLE_COMPONENT = {
  EMPTY: 'empty',
  SEAT: 'seat',
  DRIVER: 'driver',
  DOOR: 'door',
  WC: 'wc',
  STAIRCASE: 'stair'
}
